module.exports = __webpack_public_path__ + "img/xzIco (8).28c6ea2f.png";